module.exports = __webpack_public_path__ + "img/cosplay.be4e8436.png";